import { render, staticRenderFns } from "./DominioInvalido.vue?vue&type=template&id=10ccdbc4&scoped=true&"
import script from "./DominioInvalido.vue?vue&type=script&lang=js&"
export * from "./DominioInvalido.vue?vue&type=script&lang=js&"
import style0 from "./DominioInvalido.vue?vue&type=style&index=0&id=10ccdbc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ccdbc4",
  null
  
)

export default component.exports